export function rtrim(str: string, chars: string): string {
  const charList = !chars ? ' \\s\u00A0' : `${chars}`.replace(/([[\]().?/*{}+$^:])/g, '\\$1');
  const result = new RegExp(`[${charList}]+$`, 'g');
  return str.replace(result, '');
}
